// Mock data for Cheer Wave Productions

export const sampleMixes = [
  {
    id: 1,
    title: "Monash University Atlas",
    artist: "DJ James",
    audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
  },
  {
    id: 2,
    title: "Toxic Cheer Deputies",
    artist: "Cheer Wave Productions",
    audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3"
  },
  {
    id: 3,
    title: "Cheer Wave Elite Mix",
    artist: "Cheer Wave Productions",
    audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3"
  },
  {
    id: 4,
    title: "Evolution Sharks Mix",
    artist: "Cheer Wave Productions",
    audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3"
  }
];

export const featuredMixes = [
  {
    id: 1,
    title: "Dubai Athletics Cheer AQUA 25-26",
    artist: "Cheer Wave Productions",
    audioUrl: "https://customer-assets.emergentagent.com/job_extreme-cheer-build/artifacts/xamwq2ko_Dubai%20Athletics%20Cheer%20AQUA%2025-26%20%28feb5%29.mp3"
  }
];

export const features = [
  {
    id: 1,
    title: "HIGH-QUALITY MIXES",
    description: "We deliver awesome sounding and professionally-made cheer music that will fit best to your routine!"
  },
  {
    id: 2,
    title: "UNBEATABLE REVISION TERMS",
    description: "Yes, just us! We are the only service provider who offers unlimited SFX edits and music reconstruction FOR FREE!"
  },
  {
    id: 3,
    title: "FAST TURNAROUND",
    description: "You will have your music in just 3-5 days for basic mixes and 1-2 weeks for premium mixes!"
  },
  {
    id: 4,
    title: "AFFORDABLE PRICE",
    description: "You cannot find the most affordable yet best value in the market other than us!"
  }
];

export const pricingTiers = [
  {
    id: 1,
    category: "BRONZE",
    packages: [
      {
        duration: "1:30 MIN",
        price: "US$400",
        features: [
          "Choice of your radio songs",
          "Custom male and female vocals",
          "Amazing pre-made rap vocals (Male or Female)",
          "Unlimited SFX Edits"
        ]
      },
      {
        duration: "2:00 MIN",
        price: "US$450",
        features: [
          "Choice of your radio songs",
          "Custom male and female vocals",
          "Amazing pre-made rap vocals (Male or Female)",
          "Unlimited SFX Edits"
        ]
      },
      {
        duration: "2:30 MIN",
        price: "US$500",
        features: [
          "Choice of your radio songs",
          "Custom male and female vocals",
          "Amazing pre-made rap vocals (Male or Female)",
          "Unlimited SFX Edits"
        ]
      }
    ]
  },
  {
    id: 2,
    category: "SILVER",
    packages: [
      {
        duration: "1:30 MIN",
        price: "US$650",
        features: [
          "Choice of your six(6) licensed tracks from our partner music licensing platform",
          "8x 8-counts of custom rap vocals",
          "Custom male and female vocals"
        ]
      },
      {
        duration: "2:00 MIN",
        price: "US$700",
        features: [
          "Choice of your seven(7) licensed tracks from our partner music licensing platform",
          "8x 8-counts of custom rap vocals",
          "Custom male and female vocals"
        ]
      },
      {
        duration: "2:30 MIN",
        price: "US$750",
        features: [
          "Choice of your eight(8) licensed tracks from our partner music licensing platform",
          "8x 8-counts of custom rap vocals",
          "Custom male and female vocals"
        ]
      }
    ]
  },
  {
    id: 3,
    category: "GOLD",
    packages: [
      {
        duration: "1:30 MIN",
        price: "US$1100",
        features: [
          "Custom raps and custom singing vocals fit for your gym name, club, genre, and style",
          "Choice of your preferred original songs from our partner music licensing platform",
          "Custom male and female vocals"
        ]
      },
      {
        duration: "2:00 MIN",
        price: "US$1250",
        features: [
          "Custom raps and custom singing vocals fit for your gym name, club, genre, and style",
          "Choice of your preferred original songs from our partner music licensing platform",
          "Custom male and female vocals"
        ]
      },
      {
        duration: "2:30 MIN",
        price: "US$1400",
        features: [
          "Custom raps and custom singing vocals fit for your gym name, club, genre, and style",
          "Choice of your preferred original songs from our partner music licensing platform",
          "Custom male and female vocals"
        ]
      }
    ]
  }
];

export const sampleCategories = [
  {
    id: 1,
    title: "NON-LICENSED BASIC MIXES",
    image: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=600&h=400&fit=crop"
  },
  {
    id: 2,
    title: "LICENSED BASIC MIXES",
    image: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=600&h=400&fit=crop"
  },
  {
    id: 3,
    title: "LICENSED PREMIUM MIXES",
    image: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=600&h=400&fit=crop"
  },
  {
    id: 4,
    title: "CUSTOM PROJECTS",
    image: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=600&h=400&fit=crop"
  }
];